module.exports = __webpack_public_path__ + "img/isPro4_4.76d2c7f2.png";